import {
  TDisclaimerItem,
  TSortedDisclaimers,
} from '@/selectors/getCarDisclaimers';
import React, { FC, useMemo } from 'react';
import style from './style.module.scss';
import { parseLink } from '@/utils';

type TCarDisclaimersProps = {
  disclaimers: TSortedDisclaimers;
};

type TDisclaimerTextProps = {
  disclaimerText?: string;
};

const computeSeparatedText = (txt?: string) =>
  txt
    ?.split(/\[.*?\)/gim)
    .map(text => (
      <React.Fragment key={text.slice(0, 10)}>{text}</React.Fragment>
    ));

const DisclaimerText: FC<TDisclaimerTextProps> = ({ disclaimerText }) => {
  // получаем ссылки из текста вида [link text](link)
  const matchedLinks = useMemo(
    () => disclaimerText?.match(/\[.*?\]\(.*?\)/gim),
    [disclaimerText]
  );
  if (!matchedLinks) {
    return <>{disclaimerText}</>;
  }

  // получаем разбитый текст без ссылок
  const separatedText = useMemo(() => computeSeparatedText(disclaimerText), [
    disclaimerText,
  ]);
  const finalText = separatedText && [...separatedText];

  // вставляем ссылки в массив с разбитым текстом
  for (
    let i = 0, insertIndex = 1;
    i < matchedLinks.length;
    i += 1, insertIndex += 2
  ) {
    const { textOfLink, link } = parseLink(matchedLinks[i]);
    const a = (
      <a
        key={link + i}
        className={style.disclaimerLink}
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {textOfLink}
      </a>
    );
    finalText?.splice(insertIndex, 0, a);
  }

  return <>{finalText}</>;
};

const CarDisclaimers: FC<TCarDisclaimersProps> = ({ disclaimers }) => {
  const disclaimersForRender = useMemo(() => {
    const ds: TDisclaimerItem[] = [];
    disclaimers.forEach(value => ds.push(value));

    return ds;
  }, [disclaimers]);

  return (
    <div className={style.carinstockDisclaimer}>
      {disclaimersForRender.map(disclaimer => {
        return (
          <p
            className={style.carinstockDisclaimerItem}
            key={disclaimer.sortOrder}
          >
            {`${disclaimer.sortOrder}. `}
            <DisclaimerText disclaimerText={disclaimer.value} />
          </p>
        );
      })}
    </div>
  );
};

export default CarDisclaimers;
